module.exports = __webpack_public_path__ + "img/PXL_20230523_145123051.3b22915a.jpg";